<template>
    <div class="accounting-summary-loan-table">
        <div class="left" v-loading="status == 'loading'">
            <div class="title">借款合約</div>
            <div v-for="loan in datas" :key="loan.sno" class="loan-block" :class="{ active: currentSno === loan.sno }" @click="onSelectLoan(loan.sno)">
                <div class="top">
                    <div class="system-number">{{ loan.systemNo }}</div>
                    <div class="count">{{ loan.documentCount }}筆</div>
                </div>
                <div class="description">{{ loan.title }}</div>
                <div class="bottom">
                    <div class="label">總額度</div>
                    <div class="value">
                        <money :v="loan.totalAmount" />
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <LoanDrawdownRepaymentTable :status="childStatus" :datas="drawdownRepaymentData" @openDetail="onOpenDetail" @openReceipt="onOpenReceipt" @selected="$emit('selected', $event)" />
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import LoanDrawdownRepaymentTable from '@/components/dashboard/Accounting/AccountingSummary/AccountingTableView/LoanDrawdownRepaymentTable.vue';
import { PAY_WAY_LIST } from '@/assets/commonData/options';

export default {
    props: {
        status: {
            type: String,
            default: '',
        },
        datas: {
            type: Array,
            default: () => [],
        },
        conditions: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            childStatus: '',
            drawdownRepaymentData: [],

            currentSno: -1,
        };
    },
    components: { LoanDrawdownRepaymentTable },
    methods: {
        onRowClick(data) {
            this.$emit('openDetail', data.sno, data.vocherStatus);
        },
        getPayWayText(val) {
            return _.find(PAY_WAY_LIST, ['value', val])?.label || '--';
        },
        onOpenDetail(data, vocherStatus) {
            this.$emit('openDetail', data, vocherStatus);
        },
        onOpenReceipt() {
            this.$emit('openReceipt');
        },
        async onSelectLoan(sno) {
            try {
                this.currentSno = sno;
                this.childStatus = 'loading';
                await this.updateData();
            } finally {
                this.childStatus = '';
            }
            this.$emit('contract-click', this.currentSno);
        },
        async updateData() {
            if (this.currentSno < 0) return;
            const resp = await this.$api({
                url: 'AccountingSummaryPage/GetLoanDrawdownRepaymentList',
                method: 'GET',
                params: { ...this.conditions, LoanReceiptSno: this.currentSno },
            });
            this.drawdownRepaymentData = resp.data.items;
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting-summary-loan-table {
    display: grid;
    grid-template-columns: 280px calc(100% - 280px - 10px);
    width: 100%;
    height: 100%;

    .title {
        font-size: 11pt;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .left {
        padding: 20px;
        height: calc(100vh - 240px);
        overflow-y: auto;
        border-right: 1px solid #aaa;
        max-height: 650px;
        overflow: auto;
        & > *:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    .loan-block {
        cursor: pointer;
        box-sizing: border-box;
        width: 100%;
        padding: 15px;
        background-color: #f8f8f8;
        border-radius: 8px;
        .top,
        .bottom {
            display: flex;
            justify-content: space-between;
        }
        .count {
            color: $main-color;
            font-size: 10pt;
        }
        .system-number {
            font-size: 10pt;
        }
        .description {
            font-weight: bold;
            font-size: 10pt;
            margin-bottom: 10px;
        }
        .label {
            font-size: 10pt;
        }

        &.active {
            border: 2px solid $main-color;
            .description {
                color: $main-color;
            }
        }
    }

    .right {
        width: 100%;
    }
}
</style>
